import axios from './axiosApi'

export function get(url,data){
    return axios({
            url,
            method:'get',
            params:data
        })
}
export function post(url,data){
    return axios({
        url,
        method:'POST',
        data,
    })
}
export function postFormData(url,data){
    return axios({
        url,
        method:'POST',
        data,
        headers: {
            'Content-Type': 'multipart/form-data;boundary=----WebKitFormBoundaryprBFOh9ym2BgLKzK'
        }
    })
}